<template>
  <v-menu
    v-if="
      organizationHasServicesPermission &&
      sortedServices.length > 0 &&
      currentOrganization &&
      smAndUp
    "
    v-model="menu"
    location="bottom right"
  >
    <template #activator="{ props: ActivatorProps }">
      <v-btn
        v-bind="ActivatorProps"
        data-test-id="integrations-menu"
        density="comfortable"
        icon="far fa-grid-2-plus"
        variant="text"
      ></v-btn>
    </template>
    <v-list class="pt-0">
      <IntegrationsListItem
        :items="sortedServices"
        :subtitle="t('external_services.title')"
      />

      <IntegrationsListItem :items="sortedTools" subtitle="DeepBox Tools" />
    </v-list>
  </v-menu>

  <DeepMailDialog
    v-model="showDeepMailDialog"
    :organization-id="currentOrganization.group_id"
  />
</template>

<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import DeepMailDialog from '@/components/deepmail/DeepMailDialog.vue'
import { useDeepboxIntegrations } from './deepbox-integrations'
import IntegrationsListItem from './IntegrationsListItem.vue'
import type { UserMeOrganization } from '@deepcloud/api-deep-admin'
import type { Box, BoxInfo } from '@deepcloud/api-deep-box'

const props = defineProps({
  currentOrganization: {
    type: Object as PropType<UserMeOrganization>,
    required: true,
  },
  box: {
    type: Object as PropType<Box | BoxInfo>,
    default: undefined,
  },
})

const { t } = useI18n()
const { smAndUp } = useDisplay()

const menu = ref(false)

const { sortedServices, sortedTools, showDeepMailDialog } =
  useDeepboxIntegrations(
    computed(() => props.currentOrganization),
    computed(() => props.box),
  )

const organizationHasServicesPermission = computed(
  () => sortedServices.value.length > 0,
)
</script>
